import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Container from "@mui/material/Container";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LocalAirportIcon from "@mui/icons-material/LocalAirport";
import { Button, Stack, useMediaQuery } from "@mui/material";

import LogoBlack from "logo/GRACE_LOGO_V4_BLACK.png";
import LogoWhite from "logo/GRACE_LOGO_V4_WHITE.png";

import { useAuth } from "components/auth/AuthProvider";
import { useUserServiceSignIn } from "hooks/user/base";

export const Signin = () => {
  const darkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const { auth } = useAuth();
  const navigate = useNavigate();
  const signin = useUserServiceSignIn();

  useEffect(() => {
    if (auth) navigate("/");
  }, [auth]);

  useEffect(() => {
    document.title = "GRACE | signin";
  }, []); // run once on mount

  return (
    <Container
      component="main"
      maxWidth="sm"
      sx={{
        display: "flex",
        textAlign: "center",
        alignItems: "center",
        marginBlock: "auto",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        {darkMode ? (
          <img src={LogoWhite} alt="Logo 2" className="logo" />
        ) : (
          <img src={LogoBlack} alt="Logo 1" className="logo" />
        )}
      </div>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <LockOutlinedIcon />
        </Avatar>

        <Stack spacing={5} direction="row" paddingTop={5}>
          <Button
            fullWidth
            variant="contained"
            onClick={() => signin.mutate()}
            startIcon={<MicrosoftIcon color="inherit" />}
          >
            SSO
          </Button>

          <Button
            fullWidth
            href="/local/signin"
            variant="contained"
            startIcon={<LocalAirportIcon color="inherit" />}
          >
            Local
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};
